import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './login.routes';

export class OemLoginController {
    /*@ngInject*/
    constructor($auth, $scope, $mdToast) {
        this.loginInfo = {
            email: '',
            password: ''
        };

        this.$auth = $auth;
        this.buttonDisabled = false;
        this.$mdToast = $mdToast;

        $scope.$on('auth:login-error', (ev, reason) => {
            this.buttonDisabled = false;

            if (reason.errors[0].indexOf('A confirmation email was sent') !== -1) {
                this.showToast('パスワードが未設定です。パスワード設定用メールが送られていないか確認してください。');
            } else {
                this.showToast('ログインIDまたはパスワードが違います');
            }
        });
    }

    submitLogin() {
        this.buttonDisabled = true;
        this.$auth.submitLogin(this.loginInfo, { config: 'oemUser' } );
    }

    showToast(message) {
        this.$mdToast.show(
            this.$mdToast.simple()
                .content(message)
                .position('top left right')
                .hideDelay(3000)
        );
    }
}

export default angular.module('leptonApp.oemLogin', [uiRouter])
    .config(routing)
    .component('oemLogin', {
        template: require('./login.html'),
        controller: OemLoginController
    })
    .name;



// WEBPACK FOOTER //
// ./public/dev/app/account/oem_login/login.component.js